// #region imports

// --- Angular
import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  forwardRef,
  Output,
  EventEmitter,
  Renderer2,
  ViewChild,
  OnChanges,
  SimpleChanges,
  SimpleChange
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

// --- HS Code
import { SelectListItem } from '../../../models';

// #endregion

@Component({
  selector: 'hs-language-select-control',
  templateUrl: './language-select-control.component.html',
  styleUrls: ['./language-select-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LanguageSelectControlComponent),
      multi: true
    }
  ]
})
export class LanguageSelectControlComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() name: string = '';
  @Input() languages: SelectListItem[] | null = null;
  @Input() controlId: string = '';

  @Output() valueChange = new EventEmitter<string>();
  @Output() lostFocus = new EventEmitter();

  @ViewChild('ddllanguageValue', { static: true }) ddllanguageValue: any;

  onChange: ((arg0: string) => void) | undefined;
  onTouched: (() => void) | undefined;

  isDisabled = false;

  validationMessage: string = '';

  selectedValue: string | null = null;

  constructor(private renderer: Renderer2) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['languages'] && changes['languages'].currentValue) {
      console.log('languages changed', this.languages);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    if (this.ddllanguageValue && this.ddllanguageValue.nativeElement) {
      const select = this.ddllanguageValue.nativeElement;
      this.renderer.setProperty(select, 'disabled', isDisabled);
    }
  }

  writeValue(value: string): void {
    if (this.languages && value) {
      const selected = this.languages.find(v => v.value.toString() === value.toString());
      if (selected) {
        this.selectedValue = selected.value;
      }
    } else {
      this.selectedValue = null;
    }
  }

  onLanguageChanged(languageId: string): void {
    if (this.onChange && typeof this.onChange === 'function') {
      this.onChange(languageId);
    }
    this.valueChange.emit(languageId);
  }

  onFocus(): void {
    if (this.onTouched && typeof this.onTouched === 'function') {
      this.onTouched();
    }
  }

  onBlur(): void {
    this.lostFocus.emit(this);
  }
}
